'use strict';

export default function chartConfig(scope) {
  'ngInject';

  let chartConfig = {
    chart: {
      type: 'column',
      height: 300,
      events: {
        load: function () {
          // Highcharts オブジェクトへの参照をコンパクトに実現するため、arrow function を用いない
          scope.chart = this;
        }
      }
    },
    colors: ['#2b908f'],
    title: {text: '1ヶ月間のデマンド実績'},
    xAxis: {
      categories: scope.categories,
      crosshair: true,
      labels: {
        formatter: function () {
          let style = '';
          let day = scope.$filter('dayFilter')(this.value);
          if(day === '日') {
            style = 'color: #ff3131';
          } else if(day === '土') {
            style = 'color: #3737ff';
          }

          return `<span style="${style}">${scope.$filter('date')(this.value, 'M/d')} (${day})</span>`;
        }
      }
    },
    yAxis: {
      labels: {
        format: '{value}'
      },
      title: {
        text: '電力値 [kW]'
      }
    },
    legend: {
      layout: 'vertical',
      align: 'right',
      verticalAlign: 'middle',
      borderWidth: 0,
      reversed: true
    },
    tooltip: {
      enabled: true,
      shared: true,
      followPointer: true,
      formatter: function () {
        let tip_format = `<tspan style='font-size: 12px'>${scope.$filter('date')(this.x, 'M/d')} (${scope.$filter('dayFilter')(this.x)})</tspan>`;

        let point = this.points[0];
        tip_format += '<br/><span style="color:' + point.series.color + ';font-size: 12px">\u25CF</span> <span style="font-size: 14px;">' + point.series.name + ': ';
        tip_format += point.y + " kW";
        tip_format += "</span>"

        return tip_format;
      }
    },
    plotOptions: {column: {grouping: false}},
    series: [
      {
        name: '実績',
        color: '#1F85CF',
        marker: {symbol: 'circle'},
        lineWidth: 4,
        events: {
          click: function(event) {
            scope.$state.go(
              'main.demand_report_show.detail',
              { id: scope.id, type: 'demand', term: 'daily', target: event.point.date },
              { reload: true }
            );
          }
        },
        cursor: 'pointer'
      },
      {
        name: '目標電力',
        type: 'line',
        color: '#8bc34a',
        marker: {
          enabled: false,
          states: {
            hover: {
              enabled: false
            }
          }
        },
        tooltip: {
          followPointer: true,
          headerFormat: ''
        },
        pointPlacement: -0.5,
        enableMouseTracking: false
      },
      {
        name: '限界電力',
        type: 'line',
        color: '#e67e22',
        marker: {
          enabled: false,
          states: {
            hover: {
              enabled: false
            }
          }
        },
        tooltip: {
          followPointer: true,
          headerFormat: ''
        },
        pointPlacement: -0.5,
        enableMouseTracking: false
      },
      {
        name: '契約電力',
        type: 'line',
        color: '#D32F2F',
        marker: {
          enabled: false,
          states: {
            hover: {
              enabled: false
            }
          }
        },
        tooltip: {
          followPointer: true,
          headerFormat: ''
        },
        pointPlacement: -0.5,
        enableMouseTracking: false
      }
    ]
  };

  return chartConfig;
}



// WEBPACK FOOTER //
// ./public/dev/app/demand_report/monthly/monthly_demand_report.config.js